import React, { useContext, useEffect, useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Alert, Container, Spinner } from 'react-bootstrap';
import { AuthContext } from '../context/AuthContext';
import { getSafeRedirect, PENDING_LOGIN_REDIRECT_KEY } from '../lib/authRedirect';

const AuthCallbackPage = () => {
  const navigate = useNavigate();
  const { completeOAuthLogin } = useContext(AuthContext);
  const [error, setError] = useState('');

  const params = useMemo(() => new URLSearchParams(window.location.search), []);

  useEffect(() => {
    const token = params.get('token');
    const ticket = params.get('ticket');
    const nextError = params.get('error');

    if (nextError) {
      setError(nextError);
      return;
    }

    const complete = async () => {
      try {
        let sessionToken = token;
        if (!sessionToken && ticket) {
          const response = await fetch('/api/auth/exchange', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ ticket }),
          });
          const data = await response.json();
          if (!response.ok || !data.token) {
            throw new Error(data.msg || 'Your sign-in session expired. Please try again.');
          }
          sessionToken = data.token;
        }

        if (!sessionToken) {
          throw new Error('Missing login details. Please try signing in again.');
        }

        completeOAuthLogin(sessionToken);
        const redirectTarget = getSafeRedirect(window.localStorage.getItem(PENDING_LOGIN_REDIRECT_KEY));
        window.localStorage.removeItem(PENDING_LOGIN_REDIRECT_KEY);
        navigate(redirectTarget, { replace: true });
      } catch (nextError) {
        setError(nextError.message || 'Could not complete sign-in.');
      }
    };

    complete();
  }, [params, completeOAuthLogin, navigate]);

  return (
    <Container className="d-flex align-items-center justify-content-center" style={{ minHeight: '80vh' }}>
      {error ? (
        <Alert variant="danger" className="w-100" style={{ maxWidth: '460px' }}>
          {error}
        </Alert>
      ) : (
        <div className="text-center">
          <Spinner animation="border" role="status" />
          <div className="mt-3">Completing sign-in...</div>
        </div>
      )}
    </Container>
  );
};

export default AuthCallbackPage;
